/* Samonde command palette.
 *
 * Ported from VengeanceUI's Search Modal (MIT) to vanilla JS for Liquid.
 * Layered on top of the theme's own header search, never replacing it — if
 * this file fails to load, nothing on the page changes.
 *
 * Two store-specific facts drive the result rows:
 *   - search/suggest.json returns variants: [] on this store, so a product's
 *     part number has to be read off `tags`, never variants[0].sku.
 *   - those tags also carry internal ops state (brand-*, part-type-*, ebay-*,
 *     …) which must never be shown to a customer.
 */
(function () {
  'use strict';

  var root = document.getElementById('scs-root');
  if (!root) return;

  var cfg;
  try {
    cfg = JSON.parse(document.getElementById('scs-config').textContent);
  } catch (e) {
    return;
  }

  var panel = root.querySelector('.scs-panel');
  var input = root.querySelector('.scs-input');
  var scroll = root.querySelector('.scs-scroll');
  var backdrop = root.querySelector('.scs-backdrop');

  var open = false;
  var rows = [];          // focusable result rows, in visual order
  var active = -1;
  var lastFocus = null;
  var timer = null;
  var controller = null;
  var cache = Object.create(null);

  // Tag prefixes that carry ops state rather than anything a buyer should read.
  var OPS = /^(availability|brand|condition|part-type|tag|ebay|weight|status|source)-/i;

  function partNumber(tags) {
    var free = (tags || []).filter(function (t) { return !OPS.test(t); });
    if (!free.length) return '';
    // Prefer the printed form (the one that kept its separators) over the
    // stripped duplicate, then the longest.
    var printed = free.filter(function (t) { return /[-.\/]/.test(t); });
    return (printed.length ? printed : free).sort(function (a, b) {
      return b.length - a.length;
    })[0];
  }

  function condition(tags) {
    var hit = (tags || []).find(function (t) { return /^condition-/i.test(t); });
    if (!hit) return '';
    var word = hit.slice(10).replace(/-/g, ' ');
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  var money;
  try {
    money = new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency });
  } catch (e) {
    money = null;
  }
  function price(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return money ? money.format(n) : String(v);
  }

  /* ---------------------------------------------------------- rendering */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;   // textContent, never innerHTML
    return n;
  }

  // Highlight the query inside a title without ever parsing HTML.
  function titleNode(text, q) {
    var node = el('span', 'scs-title');
    var hay = text.toLowerCase();
    var needle = q.trim().toLowerCase();
    var at = needle ? hay.indexOf(needle) : -1;
    if (at < 0) {
      node.textContent = text;
      return node;
    }
    node.appendChild(document.createTextNode(text.slice(0, at)));
    var mark = el('mark', null, text.slice(at, at + needle.length));
    node.appendChild(mark);
    node.appendChild(document.createTextNode(text.slice(at + needle.length)));
    return node;
  }

  function group(label) {
    var g = el('div', 'scs-group');
    if (label) g.appendChild(el('div', 'scs-grouphead', label));
    return g;
  }

  function productRow(p, q) {
    var a = el('a', 'scs-row');
    a.href = p.url;
    a.setAttribute('role', 'option');
    a.setAttribute('aria-selected', 'false');
    a.tabIndex = -1;

    if (p.image) {
      var img = el('img', 'scs-thumb');
      img.src = p.image.replace(/(\.[a-z]+)(\?|$)/i, '_88x$1$2');
      img.alt = '';
      img.loading = 'lazy';
      img.width = 44; img.height = 44;
      // a dead CDN URL should leave a neutral tile, not a broken-image glyph
      img.addEventListener('error', function () {
        if (img.parentNode) img.parentNode.replaceChild(el('span', 'scs-thumb'), img);
      });
      a.appendChild(img);
    } else {
      a.appendChild(el('span', 'scs-thumb'));
    }

    var body = el('div', 'scs-body');
    body.appendChild(titleNode(p.title, q));

    var meta = el('div', 'scs-meta');
    var mpn = partNumber(p.tags);
    if (mpn) meta.appendChild(el('span', 'scs-mpn', mpn));
    var cond = condition(p.tags);
    if (cond) {
      if (mpn) meta.appendChild(el('span', 'scs-dot', '·'));
      meta.appendChild(el('span', null, cond));
    }
    if (meta.childNodes.length) meta.appendChild(el('span', 'scs-dot', '·'));
    meta.appendChild(el('span', 'scs-stock' + (p.available ? '' : ' is-out'),
      p.available ? cfg.t.in_stock : cfg.t.out_of_stock));
    body.appendChild(meta);
    a.appendChild(body);

    if (p.price) a.appendChild(el('span', 'scs-price', price(p.price)));
    return a;
  }

  function linkRow(label, href) {
    var a = el('a', 'scs-row');
    a.href = href;
    a.setAttribute('role', 'option');
    a.setAttribute('aria-selected', 'false');
    a.tabIndex = -1;
    a.appendChild(el('span', 'scs-title', label));
    return a;
  }

  function collect() {
    rows = Array.prototype.slice.call(scroll.querySelectorAll('.scs-row'));
    active = rows.length ? 0 : -1;
    paint();
  }

  function paint() {
    rows.forEach(function (r, i) {
      r.setAttribute('aria-selected', i === active ? 'true' : 'false');
      if (i === active) {
        r.id = r.id || 'scs-opt-' + i;
        input.setAttribute('aria-activedescendant', r.id);
        if (r.scrollIntoView) r.scrollIntoView({ block: 'nearest' });
      }
    });
    if (active < 0) input.removeAttribute('aria-activedescendant');
  }

  function showState(html) {
    scroll.textContent = '';
    var s = el('div', 'scs-state');
    s.appendChild(html);
    scroll.appendChild(s);
    rows = []; active = -1;
  }

  function quickLinks() {
    scroll.textContent = '';
    var g = group(cfg.t.jump_to);
    var ul = el('div', 'scs-list');
    cfg.links.forEach(function (l) { ul.appendChild(linkRow(l.label, l.url)); });
    g.appendChild(ul);
    scroll.appendChild(g);
    collect();
  }

  /* ------------------------------------------------------------ search */

  function render(q, products) {
    scroll.textContent = '';
    if (!products.length) {
      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(cfg.t.no_results + ' '));
      frag.appendChild(el('strong', null, q));
      frag.appendChild(document.createTextNode('. '));
      var a = el('a', null, cfg.t.request_part);
      a.href = cfg.contact_url;
      frag.appendChild(a);
      showState(frag);
      return;
    }
    var g = group(cfg.t.parts);
    var list = el('div', 'scs-list');
    products.forEach(function (p) { list.appendChild(productRow(p, q)); });
    g.appendChild(list);
    scroll.appendChild(g);

    var all = group(null);
    all.appendChild(linkRow(cfg.t.all_results.replace('[query]', q),
      cfg.search_url + '?q=' + encodeURIComponent(q)));
    scroll.appendChild(all);
    collect();
  }

  function run(q) {
    if (cache[q]) { render(q, cache[q]); return; }
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;

    var url = cfg.search_url + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8';

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) {
        var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        cache[q] = ps;
        if (input.value.trim() === q) render(q, ps);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // Never leave the buyer stuck: hand them the full search page.
        var frag = document.createDocumentFragment();
        var a = el('a', null, cfg.t.all_results.replace('[query]', q));
        a.href = cfg.search_url + '?q=' + encodeURIComponent(q);
        frag.appendChild(document.createTextNode(cfg.t.error + ' '));
        frag.appendChild(a);
        showState(frag);
      });
  }

  function onInput() {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { quickLinks(); return; }
    timer = setTimeout(function () { run(q); }, 180);
  }

  /* ------------------------------------------------------- open / close */

  function openPalette() {
    if (open) return;
    open = true;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    input.value = '';
    quickLinks();
    // rAF so the transition runs and focus lands after display flips
    requestAnimationFrame(function () { input.focus(); });
  }

  function closePalette() {
    if (!open) return;
    open = false;
    clearTimeout(timer);
    if (controller) controller.abort();
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function typing(t) {
    if (!t) return false;
    var n = t.nodeName;
    return n === 'INPUT' || n === 'TEXTAREA' || n === 'SELECT' || t.isContentEditable;
  }

  document.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      open ? closePalette() : openPalette();
      return;
    }
    if (!open && e.key === '/' && !typing(e.target) && !e.metaKey && !e.ctrlKey && !e.altKey) {
      e.preventDefault();
      openPalette();
      return;
    }
    if (!open) return;

    if (e.key === 'Escape') { e.preventDefault(); closePalette(); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!rows.length) return;
      e.preventDefault();
      active += (e.key === 'ArrowDown' ? 1 : -1);
      if (active < 0) active = rows.length - 1;
      if (active >= rows.length) active = 0;
      paint();
      return;
    }
    if (e.key === 'Enter' && active > -1 && rows[active]) {
      e.preventDefault();
      rows[active].click();
      return;
    }
    if (e.key === 'Tab') {   // the palette is the whole world while it is open
      e.preventDefault();
      input.focus();
    }
  });

  input.addEventListener('input', onInput);
  backdrop.addEventListener('click', closePalette);
  panel.addEventListener('mousemove', function (e) {
    var row = e.target.closest && e.target.closest('.scs-row');
    if (!row) return;
    var i = rows.indexOf(row);
    if (i > -1 && i !== active) { active = i; paint(); }
  });

  // Anything can open it later: <button data-samonde-search-open>
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-samonde-search-open]');
    if (t) { e.preventDefault(); openPalette(); }
  });
})();
